import { z } from 'zod';

export const PriceDetails = z.object({
    itemId: z.string().nullish(),
    price: z.number(),
    original: z.number(),
    action: z.number().nullish(),
    discount: z.number().nullish(),
    deposit: z.number().nullish(),
    substitute: z.number().nullish(),
    encoded: z.number().nullish(),
    pos: z.number().nullish(),
    negative: z.boolean().nullish().nullish(),
});
export type PriceDetails = z.infer<typeof PriceDetails>;
